import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.40002 17.6538L8.34619 16.6L12.9462 12L8.34619 7.40002L9.40002 6.34619L15.0538 12L9.40002 17.6538Z" })
});
export default SvgArrow;
